export default __webpack_public_path__ + "static/media/abilities.538c031b.png";